export default __webpack_public_path__ + "static/media/BUSQUEDA_LOCAL.2776aa5e.png";